import { push } from "connected-react-router";

const DEFAULT_LNG = "fr";

export default (url, lng = DEFAULT_LNG, redirected = false) => {
  return push(lng && lng !== DEFAULT_LNG ? `/${lng}${url}` : url);
}



// WEBPACK FOOTER //
// ./src/sagas/pushWithLng.js